/** @jsxImportSource @emotion/react */
import BestPriceBanner from "../../components/banners/BestPriceBanner";
import ResaleBanner from "../../components/banners/ResaleBanner";
import CategoriesSection from "./CategoriesSection";
import * as S from "./style";

export const Home = () => {
  return (
    <>
      <section css={S.heroStyle}>
        <div css={S.overlayStyle}>
          <h1 css={S.titleStyle}>
            What’s In My Bag:
            <br />
            15 Luxury Lifestyle
            <br />
            Essentials
          </h1>
        </div>
      </section>
      <ResaleBanner />
      <CategoriesSection />
      <BestPriceBanner />
    </>
  );
};
